/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-undef */
import React from 'react';
import { connect } from 'react-redux';
import { getIcon } from '../../Components/Functions';
import Api from '../../Server/Api';
const api = new Api();


const SettingsLayout = (props) => {
    const [saving, setSaving] = React.useState(false);
    const [consent, setConsent] = React.useState(false);
    const [virtualConsent, setVirtualConsent] = React.useState(false);
    const page = props?.page || 0;
    const pageCount = props?.pageCount || 1;

	const save = async () =>{
        if (props?.consent && !consent && props?.virtualConsent && !virtualConsent){
            notyf.open({
                type: "error",
                message: "Your consent is required to submit this form."
            });
            return;
        }
        
        if (props?.formValidator && !props?.formValidator()){
            notyf.open({
                type: "error",
                message: "Please fill all required fields to continue."
            });
            return;
            
        }
		setSaving(true);
		const res = await api.put({ endpoint: props?.endPoint || "settings/"+props?.user?.business?.id+"/" , data: { ...props?.data||{}} });
		setSaving(false);
        if(res?.id){

            // Account Profile
            if (props?.type == "profile" && props?.successCallback){
                return props?.successCallback()
            }

            // Medical Record
            if (props?.type == "medicalrecord" && props?.successCallback){
                return props?.successCallback()
            }

			notyf.open({
				type: "success",
				message: props?.title+" profile updated!",
			});	
            props?.callback && props?.callback()
			return;
		}
        if(res?.status && res?.message){
            props?.successCallback && props?.successCallback();
            notyf.open({
                type: "success",
                message: res?.detail||res?.message||"Unknown error message.",
            });
            return;
        }
		notyf.open({
			type: "error",
			message: res?.detail||res?.message||"Unknown error message.",
		});
	}
    

    return (
        <div className="form-layout">
        <div className="form-outer">
            <div className="form-header stuck-header">
                <div className="form-header-inner">
                    <div className="left">
                     <h3>{props?.title}</h3>
                     <p><b>Page:</b> {page+1} out of {pageCount}</p> 
                    </div>
                    <div className="right">
                        <div className="buttons">
                             {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                             {!props?.hideCancel  ?  (
                                <a
                                    href="#"
                                    className="button h-button is-light is-dark-outlined"
                                    onClick={(e) => {
                                        e.preventDefault()
                                        window.history.back();
                                    }}
                                >
                                    <span className="icon">
                                        <i className="fas fa-arrow-left rem-100" />
                                    </span>
                                    <span>Cancel</span>
                                </a>
                             ) : null}
                            {!props?.disableSaving && (
                            <button
                                id="save-button"
                                className={`button h-button is-primary is-raised ${saving? "is-loading":""}`}
                                onClick={() => save()}
                            >
                                {props?.btnText || "Save"}
                            </button>
                            )}
                        </div>
                    </div>
                </div>
            </div>
            {props?.children}
            {props?.formWizard ? (
            <div className="bottom form-header stuck-header">
                <style>
                    {`
                        .form-layout .form-outer .form-header.bottom {
                            padding: 12px 20px;
                            border-top: 1px solid #e5e5e5;
                            border-bottom: none;
                            -webkit-transition: all .3s;
                            transition: all .3s;
                        }
                    `}
                </style>
                <div className="form-header-inner">
                    <div className="left">
                        
      {/* <div class="field"> */}
          {/* <div class="control"> */}
              <label class="checkbox">
                  <input type="checkbox" onChange={(e) => setConsent(e.target.checked)} required/>
                  <span></span>
                  I have read and agree to the <a target={"_blank"} href={"https://evokeehealth.com/p/privacy-policy"}>Terms &
                Conditions</a>. And I agree to consent to{" "}
                <b>24Telemed</b> collecting my details.
              </label>
              <label class="checkbox">
                  <input type="checkbox" onChange={(e) => setVirtualConsent(e.target.checked)} required/>
                  <span></span>
                  I consent to virtual consultation
              </label>
{/* </div> */}
{/* </div> */}
                    </div>
                    <div className="right buttons" style={{ minWidth: "max-content" }}>
                    {page > 0 ? (
                        <button
                                    id="save-button"
                                    className={`button h-button is-danger is-raised`}
                                    onClick={props?.formWizardBack}
                                    dangerouslySetInnerHTML={{ __html: getIcon("chevron-left")+ "Back" }}
                                />
                        ): null}
                        {page < pageCount - 1 ? (
                            <button
                            id="save-button"
                            className={`button h-button is-primary is-raised`}
                            onClick={props?.formWizardNext}
                            dangerouslySetInnerHTML={{ __html: "Next "+getIcon("chevron-right") }}
                        />
                        ): null}
                    </div>
                </div>
            </div>
            ): null}
        </div>
    </div>
    )
}


const mapStateToProps = ({ user = {} }) => {
	return { user };
};

const mapDispatchToProps = (dispatch) => {
	return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(SettingsLayout);